import { NgModule } from '@angular/core';

import { KeysPipe } from './keys.pipe';
import { SchoolStatusPipe } from './school-status.pipe';
import {EntityNamePipe} from './roster-entity-pipes/entity-name.pipe';
import {EduToneEntityTitlePipe} from './roster-entity-pipes/edutone-entity-title.pipe';
import {EntityIconPipe} from './roster-entity-pipes/entity-icon.pipe';
import {EntityTitlePipe} from './roster-entity-pipes/entity-title.pipe';
import {DataSourceTypeTitlePipe} from './data-source-type-title.pipe';
import {DateBetweenPipe} from './date-pipes/date_between.pipe';
import { ExpireDatePipe } from './date-pipes/expire-date.pipe';
import { EmailNotificationTypePipe } from './friendly-names-pipes/email-notification-type.pipe';
import { DnamePipe } from './dname.pipe';
import {LabelFixerPipe} from './label-fixer.pipe';
import { IntegrationStateMetadataPipe } from './integration-state-metadata.pipe';
import {PropertyFriendlyNamePipe} from './attribute-pipes/property-friendly-name.pipe';
import {GetAvailableOrganizationsPipe} from './get-available-organizations.pipe';
import {NgcGetAvailableFilteredMappingAttributesPipe} from './attribute-pipes/get-available-filtred-mapping-attributes.pipe';
import {GetTaskAllowedMappingAttributesPipe} from './attribute-pipes/get-task-allowed-mapping-attributes.pipe';
import {KeysStringsArrayPipe} from './keys-strings-array.pipe.ts';
import {FilterAllowedEntityAttributesPipe} from '@app/core/pipes/attribute-pipes/filter-allowed-entity-attributes.pipe';
import { FilterAllowedAttributePredicatesPipe } from './attribute-pipes/filter-allowed-attribute-predicates.pipe';
import { GetPredicatesListPipe } from './attribute-pipes/get-predicates-list.pipe';
import { GetAvailableLinkedEntityListPipe } from './get-available-linked-entity-list.pipe';
import { GetAttributesListForPreCreatedFiltersPipe } from './attribute-pipes/get-attributes-list-for-pre-created-filters.pipe';
import { SuggestionPipe } from './suggestion.pipe';
import {ArrayCountriesPipe} from '@app/core/pipes/geo-data-pipes/array-countries.pipe';
import {ArrayStatesPipe} from '@app/core/pipes/geo-data-pipes/array-states.pipe';
import { SafePipe } from './html-pipes/safe.pipe';
import { SchemaFriendlyNamePipe } from './friendly-names-pipes/schema-friendly-name.pipe';
import { HighlightTextPipe } from './style-pipes/highlight-text.pipe';
import {SlickIdPipe} from './slick-id.pipe';
import { OrgUnitNamePipe } from './org-unit-name.pipe';
import {NgcFilterListByAttributePipe} from '@app/core/pipes/attribute-pipes/filter-list-by-attribute.pipe';
import {FilterAllowedAttributesPipe} from '@app/core/pipes/attribute-pipes/filter-allowed-attributes.pipe';
import { AddCurrentAttributeToListPipe } from './attribute-pipes/add-current-attribute-to-list.pipe';
import { GetSourcePropertyDisableStatusPipe } from './attribute-pipes/get-source-property-disable-status.pipe';
import { NgcModifiedByClassPipe } from './style-pipes/modified-by-class.pipe';
import { GetAvailableAttributesForMergingRulesPipe } from './attribute-pipes/get-available-attributes-for-merging-rules.pipe';
import { FileSizePipe } from './number-pipes/file-size.pipe';
import { GradeFriendlyValuePipe } from './attribute-pipes/grade-friendly-value.pipe';
import { AvailableMergingMetadataModelListPipe } from './available-merging-metadata-model-list.pipe';
import { ProblemTypesFriendlyNamePipe } from './friendly-names-pipes/problem-types-friendly-name.pipe';
import { RelativeDatePipe } from './date-pipes/relative-date.pipe';
import { DataSchemaFriendlyNamePipe } from './friendly-names-pipes/data-schema-friendly-name.pipe';
import { DataAccessStepFriendlyNamePipe } from './friendly-names-pipes/data-access-step-friendly-name.pipe';
import { ShortNumberPipe } from './number-pipes/short-number.pipe';
import { WeekDayNamesPipe } from './week-day-names.pipe';
import { ArraySlicePipe } from './array-slice.pipe';
import { UpperCaseToCamelCasePipe } from './roster-entity-pipes/upper-case-to-camel-case.pipe';
import { FilterSchoolsTabPipe } from '@app/core/pipes/filter-schools-tab.pipe';
import { CategoryFriendlyNamePipe } from './friendly-names-pipes/category-friendly-name.pipe';
import { JobTypeFriendlyNamePipe } from './friendly-names-pipes/job-type-friendly-name.pipe';
import { ChangedSchoolRolesPipe } from './changed-school-roles.pipe';
import {GradeMapPipe} from '@app/core/pipes/friendly-names-pipes/grade-map.pipe';
import {NotAssignedPipe} from '@app/core/pipes/html-pipes/not-assigned.pipe';
import {DatePipe} from '@angular/common';
import { ProcessFriendlyNamePipe } from './friendly-names-pipes/process-friendly-name.pipe';
import { DurationPipe } from './date-pipes/duration.pipe';
import { CombinedPersonDataPipe } from './combined-person-data.pipe';
import { IntegrationTaskVisibilityPipe } from './integration-task-visibility.pipe';
import { ProcessHistoryStateTitlePipe } from './process-history-state-title.pipe';
import { DatePlusGMTPipe } from './date-pipes/date-plus-gmt-pipe';
import { StateCoveragePipe } from './state-coverage.pipe';
import {EntityDetailTitlePipe} from '@app/views/databrowsing/entity-details-view/pipes/entity-detail-title.pipe';
import { FeatureToggleStatusPipe } from './feature-toggle-status.pipe';
import {AttributesFriendlyNameListPipe} from '@app/core/pipes/attribute-pipes/attributes-friendly-name-list.pipe';

@NgModule({
    declarations: [
        KeysPipe,
        SchoolStatusPipe,
        EntityNamePipe,
        EduToneEntityTitlePipe,
        EntityIconPipe,
        EntityTitlePipe,
        EmailNotificationTypePipe,
        DataSourceTypeTitlePipe,
        ExpireDatePipe,
        DateBetweenPipe,
        RelativeDatePipe,
        DnamePipe,
        LabelFixerPipe,
        IntegrationStateMetadataPipe,
        PropertyFriendlyNamePipe,
        AttributesFriendlyNameListPipe,
        KeysStringsArrayPipe,
        GetTaskAllowedMappingAttributesPipe,
        NgcGetAvailableFilteredMappingAttributesPipe,
        GetAvailableOrganizationsPipe,
        FilterAllowedAttributePredicatesPipe,
        FilterAllowedEntityAttributesPipe,
        SafePipe,
        GetPredicatesListPipe,
        GetAvailableLinkedEntityListPipe,
        GetAttributesListForPreCreatedFiltersPipe,
        SuggestionPipe,
        ArrayCountriesPipe,
        ArrayStatesPipe,
        SchemaFriendlyNamePipe,
        HighlightTextPipe,
        SlickIdPipe,
        OrgUnitNamePipe,
        NgcFilterListByAttributePipe,
        FilterAllowedAttributesPipe,
        AddCurrentAttributeToListPipe,
        GetSourcePropertyDisableStatusPipe,
        NgcModifiedByClassPipe,
        GetAvailableAttributesForMergingRulesPipe,
        FileSizePipe,
        ShortNumberPipe,
        GradeFriendlyValuePipe,
        AvailableMergingMetadataModelListPipe,
        ProblemTypesFriendlyNamePipe,
        DataAccessStepFriendlyNamePipe,
        DataSchemaFriendlyNamePipe,
        WeekDayNamesPipe,
        ArraySlicePipe,
        UpperCaseToCamelCasePipe,
        FilterSchoolsTabPipe,
        CategoryFriendlyNamePipe,
        JobTypeFriendlyNamePipe,
        ChangedSchoolRolesPipe,
        GradeMapPipe,
        NotAssignedPipe,
        ProcessFriendlyNamePipe,
        DurationPipe,
        CombinedPersonDataPipe,
        IntegrationTaskVisibilityPipe,
        ProcessHistoryStateTitlePipe,
        DatePlusGMTPipe,
        StateCoveragePipe,
        FeatureToggleStatusPipe,
    ],
    imports     : [],
    exports: [
        KeysPipe,
        SchoolStatusPipe,
        EntityNamePipe,
        EduToneEntityTitlePipe,
        EntityIconPipe,
        EntityTitlePipe,
        EmailNotificationTypePipe,
        DataSourceTypeTitlePipe,
        ExpireDatePipe,
        DateBetweenPipe,
        RelativeDatePipe,
        DurationPipe,
        DnamePipe,
        LabelFixerPipe,
        PropertyFriendlyNamePipe,
        AttributesFriendlyNameListPipe,
        KeysStringsArrayPipe,
        GetTaskAllowedMappingAttributesPipe,
        NgcGetAvailableFilteredMappingAttributesPipe,
        GetAvailableOrganizationsPipe,
        FilterAllowedAttributePredicatesPipe,
        FilterAllowedEntityAttributesPipe,
        SafePipe,
        GetPredicatesListPipe,
        GetAvailableLinkedEntityListPipe,
        GetAttributesListForPreCreatedFiltersPipe,
        SuggestionPipe,
        ArrayCountriesPipe,
        ArrayStatesPipe,
        SchemaFriendlyNamePipe,
        HighlightTextPipe,
        SlickIdPipe,
        OrgUnitNamePipe,
        NgcFilterListByAttributePipe,
        FilterAllowedAttributesPipe,
        AddCurrentAttributeToListPipe,
        GetSourcePropertyDisableStatusPipe,
        NgcModifiedByClassPipe,
        GetAvailableAttributesForMergingRulesPipe,
        FileSizePipe,
        ShortNumberPipe,
        GradeFriendlyValuePipe,
        AvailableMergingMetadataModelListPipe,
        ProblemTypesFriendlyNamePipe,
        DataAccessStepFriendlyNamePipe,
        DataSchemaFriendlyNamePipe,
        WeekDayNamesPipe,
        ArraySlicePipe,
        UpperCaseToCamelCasePipe,
        FilterSchoolsTabPipe,
        CategoryFriendlyNamePipe,
        JobTypeFriendlyNamePipe,
        ChangedSchoolRolesPipe,
        GradeMapPipe,
        NotAssignedPipe,
        ProcessFriendlyNamePipe,
        CombinedPersonDataPipe,
        IntegrationTaskVisibilityPipe,
        ProcessHistoryStateTitlePipe,
        DatePlusGMTPipe,
        StateCoveragePipe,
        FeatureToggleStatusPipe
    ],
    providers: [
        EduToneEntityTitlePipe,
        GetAttributesListForPreCreatedFiltersPipe,
        PropertyFriendlyNamePipe,
        SuggestionPipe,
        DnamePipe,
        DatePipe,
        SchemaFriendlyNamePipe,
        IntegrationTaskVisibilityPipe,
        EntityDetailTitlePipe,
        DatePlusGMTPipe,
        GetAvailableLinkedEntityListPipe
    ]
})

export class PipesModule {

}
